import { render, staticRenderFns } from "./AddBase.vue?vue&type=template&id=05d85518&scoped=true&"
import script from "./AddBase.vue?vue&type=script&lang=js&"
export * from "./AddBase.vue?vue&type=script&lang=js&"
import style0 from "./AddBase.vue?vue&type=style&index=0&id=05d85518&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d85518",
  null
  
)

export default component.exports